<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <!-- chip outline top -->
    <path d="M3 13.9V14.8C3 16.68 4.5 18.2 6.4 18.2H17.6C19.5 18.2 21 16.68 21 14.8V13.9" />
    <!-- chip outline bottom -->
    <path d="M21 9.2C21 7.32 19.5 5.8 17.6 5.8H6.4C4.5 5.8 3 7.32 3 9.2" />
    <!-- wristband -->
    <path d="M1.6 14.2C2.61 13.75 3.61 13.63 4.6 14.2" />
    <path d="M1.6 9.8C2.61 9.35 3.61 9.23 4.6 9.8" />
    <path d="M19.4 14.2C20.41 13.75 21.41 13.63 22.4 14.2" />
    <path d="M19.4 9.8C20.41 9.35 21.41 9.23 22.4 9.8" />
    <path d="M4.6 9.8V14.2" />
    <path d="M19.4 9.8V14.2" />
</svg>